import api from './api';

export const productService = {
    /**
     * Get all products, optionally filtered by category
     * @param {string} category - Optional category filter (roastery or merchandise)
     * @returns {Promise} Response with { products }
     */
    getAll: async (category = null) => {
        const params = category ? { category } : {};
        return api.get('/products', { params });
    },

    /**
     * Get single product by ID
     * @param {number} id - Product ID
     * @returns {Promise} Response with { product }
     */
    getById: async (id) => {
        return api.get(`/products/${id}`);
    },
};
